<template>
    <ListItemButton v-if="!socialShareDisabled" icon-name="share-nodes" dusk="socialShareButton" @click="shareIssue">
        <span>
            {{ localizations[lang].tooltips.share }}
        </span>
    </ListItemButton>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ListItemButton from '../Components/list/ListItemButton.vue';
import { uiAPI } from '../../../src/js/communication';

export default {
    components: { ListItemButton },
    emits: ['share'],
    computed: {
        ...mapState(['issue', 'title', 'localizations', 'lang']),
        ...mapGetters(['canUseNativeShare', 'socialShareDisabled']),
    },
    methods: {
        ...mapMutations(['openSocialShare']),
        shareIssue() {
            this.canUseNativeShare ? this.shareUsingShareApi() : this.openSocialShare();
            this.$emit('share');
        },
        shareUsingShareApi() {
            if (this.socialShareDisabled) return;
            const issueDescription = this.issue.descriptionRawText || '';

            const text = issueDescription.length > 90 ? `${issueDescription.substring(0, 90)}...` : issueDescription;

            const payload = {
                title: `${this.localizations[this.lang].imReading} ${this.title}`,
                text,
            };

            // The book is shared by its public page. issue_url is the reader,
            // which links a position in the book (add-ons, highlights); this
            // share carries none, so without a share_url it sends no URL.
            if (this.issue.share_url) {
                payload.url = this.issue.share_url;
            }

            uiAPI.shareContent(payload);
        },
    },
};
</script>

<style scoped lang="scss"></style>
